import { now } from "./time";

export const QUIZ_COOLDOWN_ERROR_CODE = 'quiz_cooldown';

export const isQuizAllowedToStart = (allowDate: number | undefined | null): boolean =>
    allowDate != null && allowDate <= now();

export const parseQuizCooldownAllowDate = (error: unknown): number | undefined => {
    const data = (error as { response?: { data?: Record<string, unknown> } })?.response?.data;
    if (!data)
        return undefined;

    const payload = typeof data.message === 'object' && data.message !== null
        ? data.message as Record<string, unknown>
        : data;

    if (payload.code === QUIZ_COOLDOWN_ERROR_CODE && typeof payload.allowDate === 'number')
        return payload.allowDate;

    return undefined;
};
